import React from 'react';

import PropTypes from 'prop-types';

import Button from '../commons/Button';

import { getDesiredCoverages } from '../../utils/helper-functions';

const PlanCard = ({
  plan,
  highlighted,
  selectedPeriodicity,
  displayedOnMobile,
  onSelectPlan,
}) => {
  const lowercasePeriodicity = selectedPeriodicity.toLowerCase();
  const capitalizedPeriodicity = selectedPeriodicity.charAt(0).toUpperCase()
    + selectedPeriodicity.slice(1);
  const paymentAmount = plan.forma_pagos[capitalizedPeriodicity].montos.subSecuentes.montoRedondeado;
  const firstPayment = plan.forma_pagos[capitalizedPeriodicity].montos.primerRecibo.montoRedondeado;
  const totalPayment = plan.forma_pagos[capitalizedPeriodicity].montos.total.montoRedondeado;
  const includedCoverages = getDesiredCoverages('included', plan.forma_pagos[capitalizedPeriodicity]);
  const excludedCoverages = getDesiredCoverages('excluded', plan.forma_pagos[capitalizedPeriodicity]);

  let planClasses = 'plan-card';
  if (highlighted) planClasses += ' -highlighted';
  if (displayedOnMobile) planClasses += ' -displayed';

  return (
    <div className={planClasses}>
      <h3 className="title text-center">{plan.plan.name}</h3>
      <div className="card-inner text-center">
        <p className="short-name">
          Cobertura&nbsp;
          {plan.plan.name}
        </p>
        <p>
          {`Pago ${selectedPeriodicity} de`}
        </p>
        <p className="payment-amount">
          {lowercasePeriodicity !== 'anual' ? `$${paymentAmount}` : `$${totalPayment}`}
        </p>
        {
          lowercasePeriodicity !== 'anual'
          && (
            <>
              <p>{`Primer Recibo: $${firstPayment}`}</p>
              <p>{`Total a pagar: $${totalPayment}`}</p>
            </>
          )
        }
        <hr />
        <ul className="coverage-list text-left">
          {
            includedCoverages.map((coverage) => (
              <li key={coverage.key}>
                <p>{coverage.descripcionCobertura}</p>
                {
                  coverage.sumaAsegurada === 'Amparada' || coverage.sumaAsegurada === null
                    ? (
                      <p>
                        <span className="text-strong">
                          {coverage.sumaAsegurada || 'Amparada'}
                        </span>
                      </p>
                    )
                    : (
                      <p>
                        <span>
                          Suma Asegurada:&nbsp;
                          <strong>{coverage.sumaAsegurada}</strong>
                        </span>
                      </p>
                    )
                }
              </li>
            ))
          }
          {
            excludedCoverages.map((coverage) => (
              <li key={coverage.key} className="-disabled">
                <p>{coverage.descripcionCobertura}</p>
              </li>
            ))
          }
        </ul>
        <Button
          onClick={
            () => onSelectPlan(
              plan.plan.name,
              plan?.forma_pagos[selectedPeriodicity]?.cotizacion?.numeroCotizacion,
              firstPayment,
              paymentAmount,
              totalPayment,
              plan,
            )
          }
          label="Contratar"
          buttonClasses="align-center"
          iconClasses="" />
      </div>
    </div>
  );
};

PlanCard.propTypes = {
  highlighted: PropTypes.bool,
  plan: PropTypes.object.isRequired,
  selectedPeriodicity: PropTypes.string.isRequired,
  displayedOnMobile: PropTypes.bool,
  onSelectPlan: PropTypes.func,
};

PlanCard.defaultProps = {
  displayedOnMobile: false,
  highlighted: false,
  onSelectPlan: () => { },
};

export default PlanCard;
